import React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

function SendMessageIcon(props: SvgProps) {
  return (
    <Svg width={28} height={28} viewBox="0 0 28 28" fill="none" {...props}>
      <Path
        d="M14 2.042A11.958 11.958 0 1025.96 14 11.97 11.97 0 0014 2.04zm7 11.97a1.169 1.169 0 01-1.656 0l-4.165-4.165v10.616a1.167 1.167 0 01-2.334 0v-10.5L8.68 14.058a1.167 1.167 0 11-1.645-1.645l5.309-5.285a2.415 2.415 0 011.703-.712c.317 0 .63.063.922.187.295.117.562.296.781.525l5.285 5.285a1.166 1.166 0 01-.046 1.598H21z"
        fill="#10827E"
      />
    </Svg>
  );
}

export default SendMessageIcon;
